import { useNavigate } from "react-router-dom";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import { Banner, BlueLarge } from "../../images/index";
import {
  IdeaConcept,
  RetailGroup,
  Group1,
  Group2,
  Group3,
  Group4,
  CaseStudyImage,
  Image338,
} from "../../images/Industries";
import { useEffect, useState } from "react";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";

const challenges = [
  "High spoilage rates and perishable inventory losses",
  "Complex supplier and distribution networks",
  "Rising customer expectations for personalization",
  "Competition from digital-first grocery platforms",
  "Limited real-time visibility across stores and warehouses",
];

const features = [
  {
    icon: Group1,
    text: "Deep domain expertise in wholesale and retail",
  },
  {
    icon: Group2,
    text: "GroceryAI™ Framework with reusable AI/ML components",
  },
  {
    icon: Group3,
    text: "Proven success with national grocery chains and distributors",
  },
  {
    icon: Group4,
    text: "U.S.–India hybrid delivery model for 24/7 innovation",
  },
];

function RWG() {
  const navigate = useNavigate();
  const slug = useSlug();
  const [metaData, setMetaData] = useState({});
  useEffect(() => {
    const fetchMetaData = async () => {
      const data = await getPagesBySlug(slug);
      setMetaData(data?.meta || {});
    };
    fetchMetaData();
  }, [slug]);
  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <SEO {...metaData} />
      <div className="">
        <div className="relative min-h-[500px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 -z-10 md:h-full h-[calc(100vh-0px)] w-full object-cover"
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0 mx-auto left-0 right-0">
            <div className="max-w-2xl font-roboto space-y-6 mt-16">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569]">
                  Where Technology Meets Industry
                </span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Retail & Grocery
              </h1>
              <p className="text-md text-[#404040]">
                Transforming Grocery Operations with AI and Automation
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-16">
              <img src={Image338} alt="Image" className="obkect-contain" />
            </div>
          </div>
        </div>

        <section className="py-14 px-4 md:px-20 font-roboto bg-[#F7F7F7]">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="mb-12">
              <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                Challenges We Solve
              </h2>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1 w-full">
                <ul className="space-y-6 ms-5">
                  {challenges.map((item, idx) => (
                    <li
                      key={idx}
                      className="list-disc text-xl text-[#0F172A] font-medium"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex-1 flex items-center justify-center">
                <img
                  src={IdeaConcept}
                  alt="Idea Concept"
                  className="h-[250px] object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 px-4 md:px-20 font-roboto bg-white">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="max-w-4xl mx-auto mb-12 text-center">
              <span className="flex items-center justify-center font-bold text-lg tracking-wider mb-4 space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                Our Solutions
              </h2>
              <p className="text-[#404040] font-400 text-lg text-base">
                We empower businesses with AI-driven tools and automation that
                optimize operations, enhance customer experiences, and unlock
                measurable value across the supply chain:
              </p>
            </div>
            <img
              src={RetailGroup}
              alt="Our Solutions"
              className="inset-0 -z-10 md:h-full w-full object-cover"
            />
          </div>
        </section>

        <section className="bg-[#F7F7F7] py-16 px-2 font-roboto">
          <div className="flex justify-center mb-4">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
          </div>

          <h2 className="text-5xl md:text-7xl font-extrabold text-[#434253] text-center mb-6 px-6 md:px-0">
            Why TechProjects for Grocery?
          </h2>
          <p className="text-center text-lg text-[#404040] mb-14 font-400 tracking-tight">
            Wholesale Grocery Leader – AI Demand Forecasting
          </p>
          <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 px-6 md:px-0">
            {features.map((feature, idx) => (
              <div key={idx} className="flex items-center bg-white p-8">
                <img src={feature.icon} alt={feature.text} className="mr-4" />
                <span className="text-lg text-[#0F172A] font-400">
                  {feature.text}
                </span>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-white py-16 px-2 font-roboto">
          <div className="flex justify-center mb-4">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
          </div>

          <h2 className="text-5xl md:text-7xl font-extrabold text-[#434253] text-center mb-6">
            Impact & Case Study
          </h2>
          <p className="text-center text-lg text-[#404040] mb-14 font-400 tracking-tight">
            Wholesale Grocery Leader – AI Demand Forecasting
          </p>
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto ">
            <img
              src={CaseStudyImage}
              alt="Impact & Case Study"
              className="inset-0 -z-10 md:h-full w-full object-cover"
            />
          </div>
        </section>
        <section
          className="text-white flex items-center py-8 md:py-[4rem] relative overflow-hidden bg-cover bg-no-repeat font-roboto"
          style={{ backgroundImage: `url(${BlueLarge})` }}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center px-3 md:px-6">
            <h2 className="text-3xl md:text-4xl xl:text-6xl max-w-4xl mx-auto font-extrabold text-white leading-tight mb-[2rem] md:mb-[3rem]">
              Retail & Grocery
            </h2>
            <p className="text-lg font-400 text-[#CBD5E1]">
              With TechProjects, you can optimize inventory management, protect
              margins, and strengthen customer loyalty — enabled by AI and
              intelligent automation.
            </p>
            <div className="flex flex-wrap  justify-center mt-10 gap-6 md:gap-12">
              <button
                onClick={handleClick}
                type="submit"
                className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                Contact Us Now
              </button>
            </div>
          </div>
        </section>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default RWG;
